module.exports = __webpack_public_path__ + "static/media/books.680ca0ef.png";